export function useAccountContextMenu(options) {
    const hasInstrumentTypeOffset = options.items.some((item) => item.type === 'account' && !isNullOrUndefined(item.instrumentType));
    return {
        hasInstrumentTypeOffset
    };
}
